var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusKyc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "#1A496D",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 30.6666L29.3337 36L41.3337 24M53.3337 32C53.3337 45.0892 39.0564 54.609 33.8616 57.6397C33.2713 57.9841 32.9761 58.1563 32.5595 58.2456C32.2362 58.315 31.7645 58.315 31.4412 58.2456C31.0246 58.1563 30.7294 57.9841 30.139 57.6397C24.9442 54.609 10.667 45.0892 10.667 32V19.2469C10.667 17.1149 10.667 16.0489 11.0157 15.1325C11.3237 14.323 11.8243 13.6007 12.4741 13.0281C13.2096 12.3798 14.2078 12.0055 16.2041 11.2569L30.5022 5.89511C31.0566 5.68722 31.3338 5.58327 31.6189 5.54206C31.8719 5.50551 32.1288 5.50551 32.3817 5.54206C32.6669 5.58327 32.9441 5.68722 33.4984 5.89511L47.7966 11.2569C49.7929 12.0055 50.791 12.3798 51.5266 13.0281C52.1764 13.6007 52.6769 14.323 52.985 15.1325C53.3337 16.0489 53.3337 17.1149 53.3337 19.2469V32Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusKyc);
export default __webpack_public_path__ + "static/media/status-kyc.2305c930a40ff2fa8f6b6770dd0ee074.svg";
export { ForwardRef as ReactComponent };